// extracted by mini-css-extract-plugin
export default {"backdrop":"social-ugc-actions-Backdrop__backdrop--3colg"};